<template>
  <div class="page">
    <el-form>
      <el-form-item>
        <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
      </el-form-item>
    </el-form>
    <!--    <div class="form-box">-->
    <!--      <el-form-->
    <!--          :inline="true"-->
    <!--          @submit.native.prevent-->
    <!--          label-width="130px"-->
    <!--          style="margin-bottom: 20px"-->
    <!--      >-->
    <!--        <el-form-item label="分销商名称:">-->
    <!--          <el-input v-model="searchData.productSkuName" placeholder="请输入分销商名称" clearable></el-input>-->
    <!--        </el-form-item>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item style="margin-left: 40px">-->
    <!--          <el-button type="primary" @click="searchFun">筛选</el-button>-->
    <!--          <el-button type="danger" @click="resetFun">重置</el-button>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--    </div>-->
    <!--列表-->
    <el-table :data="tableList" highlight-current-row v-loading="listLoading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" fixed align="center"></el-table-column>
      <el-table-column prop="name" label="名称" align="center"></el-table-column>
      <el-table-column prop="type" label="类型" align="center"></el-table-column>
      <el-table-column prop="menuIds" label="菜单Id集合" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span v-if="Array.isArray( scope.row.orderPurchases) &&  scope.row.orderPurchases.length > 0">{{-->
        <!--                            scope.row.orderPurchases[0].orderPurchaseNo-->
        <!--                          }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
    </el-pagination>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(2)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="isEdit ? '编辑' : '新增模板'" :visible.sync="setPermissionsDialog" v-if="setPermissionsDialog"
      v-model="setPermissionsDialog" :check-strictly='isCheck' :close-on-click-modal="false">
      <el-form @submit.native.prevent label-width="130px" style="margin-bottom: 20px">
        <el-form-item label="模板名称:">
          <el-input v-model="templateName" placeholder="请输入模板名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="模板权限选择:">
          <el-tree :data="permissionsList" show-checkbox node-key="id" ref="tree" highlight-current
            :props="defaultProps">
          </el-tree>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="closeSet">取消</el-button>
        <el-button type="primary" @click.native="submitPermissions" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="detailDialog" v-if="detailDialog" :close-on-click-modal="false">
      <el-form @submit.native.prevent label-width="130px" style="margin-bottom: 20px">
        <el-form-item label="模板名称:">
          <el-input v-model="templateName" placeholder="请输入模板名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="模板权限选择:">
          <el-tree :data="permissionsList" show-checkbox node-key="id" ref="tree" highlight-current
            :props="defaultProps">
          </el-tree>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="closeSet1">取消</el-button>
        <el-button type="primary" @click.native="submitPermissions1" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderExport,
  OrderLogisticUpload,

  TenantPermissionTemplateGetAll,
  TenantPermissionTemplateGet,
  TenantPermissionTemplateUpdate,
  TenantPermissionTemplateDelete,
  TenantPermissionTemplateCreate,
  GetMenuTree, TenantSetPermissions
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [{ 'id': 1 }],
      productNavTypeTreeList: [],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        // orderNo: null,
        // beginCreateTime: null,
        // endCreateTime: null,
        // productSkuName: null,
        // receivingName: null,
        // receivingMobile: null,
        // Status: 4,
      },
      value: '',
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
      permissionsList: [],
      submitLoading: false,
      setPermissionsDialog: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      templateName: '',
      isEdit: false,
      isCheck: false,
      checkedIds: [],
      rowId: null,
      detailDialog: false,
    };
  },
  created() {
    // this.getProductNavTypeTree();
    // this.getBrandList();
    this.getTableList();
    this.getpermissionsList();
  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      console.log('this.buttonList_toolBar', this.buttonList_toolBar);
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
      console.log('this. this.buttonList_table', this.buttonList_table);
    }
  },
  methods: {
    async detail(button, index, row) {
      this.detailDialog = true;
      let res = TenantPermissionTemplateGet({ Id: row.id });
      this.$nextTick(() => {
        let arr = row.menuIds.split(',');
        const arr1 = []
        arr.forEach(f => {
          if (!this.$refs.tree.getNode(f).childNodes || !this.$refs.tree.getNode(f).childNodes.length) {
            arr1.push(f)
          }
        })
        this.$refs.tree.setCheckedKeys(arr1)
      })
      // this.checkedIds = arr;
      // console.log('arr', arr)
      // this.isCheck = true;
      // this.$nextTick(()=>{
      //   this.$refs.tree.setCheckedKeys(arr);
      //   this.isCheck = false;
      // })
    },
    del(button, index, row) {
      this.$confirm("确认提交吗？", "提示", {
        closeOnClickModal: false,
      }).then(async () => {
        let res = await TenantPermissionTemplateDelete({ Id: row.id });

        if (res.data.success) {
          this.$message.success('刪除成功');
          this.getTableList();
        } else {
          this.$message.error(res.data.error.message || '刪除失败, 请重试')
        }
      }).catch(() => { });
    },

    edit(button, index, row) {
      this.setPermissionsDialog = true;
      this.isEdit = true;
      this.rowId = row.id
      console.log('row', row)
      this.templateName = row.name;
      // let arr = row.menuIds.split(',');
      // this.checkedIds = arr;
      // this.isCheck = true;
      // this.$nextTick(()=>{
      //   this.$refs.tree.setCheckedKeys(arr);
      //   this.isCheck = false;
      // })
      this.$nextTick(() => {
        let arr = row.menuIds.split(',');
        const arr1 = []
        arr.forEach(f => {
          if (!this.$refs.tree.getNode(f).childNodes || !this.$refs.tree.getNode(f).childNodes.length) {
            arr1.push(f)
          }
        })
        this.$refs.tree.setCheckedKeys(arr1)
      })
    },
    create() {
      this.setPermissionsDialog = true;
    },
    closeSet() {
      this.templateName = '';
      this.setPermissionsDialog = false;
    },
    closeSet1() {
      this.templateName = '';
      this.detailDialog = false;
    },
    submitPermissions1() {
      this.templateName = '';
      this.detailDialog = false;
    },
    submitPermissions() {
      this.$confirm("确认提交吗？", "提示", {
        closeOnClickModal: false,
      }).then(() => {

        // let test1 = this.$refs.tree.getCheckedNodes();
        // let test2 = this.$refs.tree.getCheckedNodes(false, true);
        // let test3 = this.getCheckedKeys();

        // let params = {
        //   tenantId: this.currentRow.id,
        //   permissions: this.getCheckedKeys()
        // };


        let checkedNodes = this.$refs.tree.getCheckedNodes(false, true)
        let checkedIds = [];
        checkedNodes.forEach(o => {
          checkedIds.push((o.id));
        })
        checkedIds = checkedIds.join(',');

        console.log('checkedIds', checkedIds);
        let params = {
          name: this.templateName,
          type: 0,
          menuIds: checkedIds,
        };
        console.log('params', params)

        if (this.isEdit === true) {
          params.id = this.rowId;
          console.log('edit params', params);
          TenantPermissionTemplateUpdate(params).then(result => {
            console.log('res----------------', result);
            if (result.data.success) {
              this.$message.success('设置成功')
              this.templateName = '';
              this.setPermissionsDialog = false;
              this.getTableList();
            } else {
              this.$message.error(result.data.message || '设置失败,请重试')
            }
          })
        } else {
          TenantPermissionTemplateCreate(params).then(result => {
            console.log('res----------------', result);
            if (result.data.success) {
              this.$message.success('设置成功')
              this.templateName = '';
              this.setPermissionsDialog = false;
              this.getTableList();
            } else {
              this.$message.error(result.data.message || '设置失败,请重试')
            }
          })
        }


        // let that = this;
        // TenantSetPermissions(params).then((res) => {
        //   that.submitLoading = false;
        //   if (res.data.success) {
        //     that.$message.success('提交成功');
        //     that.setPermissionsDialog = false;
        //   } else {
        //     that.$message.error(res.data.error.message)
        //   }
        // });
        //
        //
        // this.roleForm.grantedPermissions = this.getCheckedKeys();
        // let that = this;
        // UpdateRole(that.roleForm).then((res) => {
        //   that.submitLoading = false;
        //   if (res.data.success) {
        //     that.$message.success('提交成功');
        //     that.setPermissionsDialog = false;
        //   } else {
        //     that.$message.error(res.data.error.message)
        //   }
        // });
      }).catch(() => { });
    },
    getpermissionsList() {
      GetMenuTree().then((res) => {
        console.log('res---------', res.data.result.children);
        this.permissionsList = this.loopMenuTree([res.data.result])[0].children;
        let test = this.permissionsList;
        console.log('permissionsList', this.permissionsList);
        let test2 = 1;
      });
    },
    invoiceRecord() {
      this.$router.push('/Financial/InvoiceManage/InvoiceRecords')
    },
    makeInvoice() {
      this.$router.push('/Financial/InvoiceManage/Detail')
    },
    dealerDetail() {
      this.$router.push('/Financial/DealerFinancialManage/Detail')
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    orderDetail(button, index, row) {
      // this.$router.push(
      //   `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`
      // );
    },
    async getTableList(searchData) {
      this.loading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await TenantPermissionTemplateGetAll(this.searchData);
      if (res.data.success) {
        this.listLoading = false;
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        this.$message.error(res.data.msg)
      }
      console.log('已收货', res);
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    // 递归封装菜单树
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        if (!item.data.Id) {
          item.id = 0 + '',
            item.label = '根节点'
        } else {
          item.id = item.data.Id + '';
          item.label = item.data.DisplayName;
        }
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    // loopMenuTree(treeList) {
    //   // console.log('treeList',treeList)
    //   const newList = treeList.filter(item => {
    //     item.value = item.data.Id;
    //     item.label = item.data.Name;
    //     delete item.data
    //     if (!item.children.length) {
    //       delete item.children
    //     } else {
    //       this.loopMenuTree(item.children)
    //     }
    //     return true;
    //   })
    //   return newList;
    // },
    searchFun() {
      this.searchData.PageIndex = 1;
      this.getTableList();
    },
    handlePicker(date) {
      if (date == null) {
        this.valueTime = []
        this.searchData.beginCreateTime = null
        this.searchData.endCreateTime = null
      } else {
        this.searchData.beginCreateTime = date[0]
        this.searchData.endCreateTime = date[1]
      }
    },
    resetFun() {
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        orderNo: '',
        productSkuName: '',
        receivingName: '',
        receivingMobile: '',
        status: 2,
        orderPurchaseNo: '',
      },
        this.getTableList();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      this.listLoading = false;
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.el-input,
.el-select,
.el-cascader,
.el-autocomplete {
  width: 200px;
}

.form-box {
  background: #ebeef5;
  padding: 10px 10px 0 10px;
  /* margin-bottom: 20px; */
}

section {
  padding: 20px;
}

.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

